import React, { useEffect, useState } from "react";
import CategoryIcons from "./CategoryIcons";

// Services
import { lineService } from "../services/line.service";

// Components
import TitleComponent from "./TitleComponent";

function CategoryComponent(props) {
    const [selectedCategory, setSelectedCategory] = useState(0);
    const [lines, setLines] = useState([]);


    const handleLine = async (ids) => {
        setSelectedCategory(ids);
        await props.handleSelectedLine(ids);
    };

    const extractLinesToCategories = async (items) => {

        if (items && items?.length > 0) {

            var categories = await lineService.fetchCategoriesConfig();

            // Remove os items antes do ID 12 (regra da API)
            const breakId = 12;
            const filteredLines = items.filter(line => line.line_id >= breakId);

            let newLinesList = [];

            filteredLines.forEach(item => {
                const category = categories.find(x => x.references_ids.includes(item.line_id));

                if (category && !newLinesList.find(x => x.order === category.order)) {
                    newLinesList.push(category);
                }
            });

            // Ordena a lista final pelo campo 'order'
            newLinesList.sort((a, b) => a.order - b.order);

            setLines(newLinesList);
        }
    };


    useEffect(() => {
        (async () => {
            try {
                await extractLinesToCategories(props.lines);
            } finally { }
        })();
    }, [props.lines]);



    useEffect(() => {
        setSelectedCategory(0);
    }, [props.disabled])

    const renderBox = (item) => {
        return (
            <div key={item.index} className="category-item" onClick={async () => { handleLine(item.ids) }}>
                <div className={item.ids === selectedCategory ? "category-box-active" : "category-box"}>
                    <CategoryIcons icon={item.icon} />
                </div>
                <div className="category-box-text">{item.text}</div>
            </div>
        );
    };

    return (
        <div className={`${props.disabled ? 'category disableds' : 'category'}`} >
            <TitleComponent title="Escolha a categoria e quantidade dos itens" />
            <div className="category-scroll-container">
                {lines && lines.map((item, index) => (
                    renderBox({ index: index, active: true, text: item.display, icon: item.icon_definition, ids: item.references_ids })
                ))}


            </div>
        </div>
    );
}

export default CategoryComponent;
